import {FormControl} from "@angular/forms";
import {IControlObject} from "frontier";
import {ColumnsModel} from "@syncfusion/ej2-angular-querybuilder";

export interface ITestrulesForm {
  description: FormControl<string>;
  active: FormControl<boolean>;
}

export interface IOperator {
  key: string;
  value: string;
}

export enum ETestruleCategory {
  trapoError = 'Stammd. fehlen',
  trapoWarning = 'Stammd. auffällig',
  checkError = 'Daten fehlen',
  checkWarning = 'Daten auffällig',
}

export enum EConditionAttributes {
  application = 'Application',
  active = 'active',
  description = 'Description',
  guid = 'Guid',
}

export interface ITestrulesFormValue extends ITestrulesFormTemplate {
  application: ETestruleCategory;
  controlObj: IControlObject;
  rowidx: number;
  guid: string;
  parent: string;
  ruleGuid?: string;
}

export interface ITestrulesFormTemplate {
  description: string;
  active: boolean;
  selected: boolean;
}

export enum ETestruleFieldType {
  string = "string",
  object = "object",
  date = "date",
  boolean = "boolean",
  decimal = "decimal",
  integer = "integer",
  property = "property",
  function = "function",
}

export enum ESyncfusionFieldType {
  string = "string",
  number = "number",
  date = "date",
  boolean = "boolean",
}

export interface ITestruleField extends Omit<ColumnsModel, 'type' | 'columns'> {
  type?: ESyncfusionFieldType | ETestruleFieldType;
  table?: string;
  apiType: ETestruleFieldType;
  columns: ITestruleField[];
}
